import PropTypes from 'prop-types';

/**
 * Dynamically creates a function component with a given name
 * The idea for this function is two create differently named functions
 * with the same functionality, so that they can pass different kinds of
 * validations based on usage and type.
 *
 * @param {String} name The name of the component
 * @return {Function} Variant-compliant component
 */
const variantFactory = (name) => {
    const container = {
        [name]: ({ render }) => {

            if (typeof render === 'function') {
                render = render();

                if (render === undefined) {
                    render = null;
                }
            }

            return render;
        }
    };

    container[name].propTypes = {
        render: PropTypes.oneOfType([
            PropTypes.node,
            PropTypes.func
        ]).isRequired
    };

    return container[name];
};

const Variant = variantFactory('Variant');
const Control = variantFactory('Control');

Variant.propTypes.v = PropTypes.string;

export {
    Variant,
    Control
};
